var map = {
	"./element/Air.svg": 1356,
	"./element/Earth.svg": 1357,
	"./element/Fire.svg": 1358,
	"./element/Water.svg": 1359,
	"./element/Wind.svg": 1360,
	"./moon/Aquarius.svg": 1361,
	"./moon/Aries.svg": 1362,
	"./moon/Cancer.svg": 1363,
	"./moon/Capricorn.svg": 1364,
	"./moon/Gemini.svg": 1365,
	"./moon/Leo.svg": 1366,
	"./moon/Libra.svg": 1367,
	"./moon/Pisces.svg": 1368,
	"./moon/Sagittarius.svg": 1369,
	"./moon/Scorpio.svg": 1370,
	"./moon/Taurus.svg": 1371,
	"./moon/Virgo.svg": 1372,
	"./star/Aquarius.svg": 1373,
	"./star/Aries.svg": 1374,
	"./star/Cancer.svg": 1375,
	"./star/Capricorn.svg": 1376,
	"./star/Gemini.svg": 1377,
	"./star/Leo.svg": 1378,
	"./star/Libra.svg": 1379,
	"./star/Pisces.svg": 1380,
	"./star/Sagittarius.svg": 1381,
	"./star/Scorpio.svg": 1382,
	"./star/Taurus.svg": 1383,
	"./star/Virgo.svg": 1384
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1355;